<template>
  <div class="head-user">
    <div class="user-info" v-if="logined">
      <i class="iconfont icon-user"></i>
      <a class="user-name" href="javascript:;" @click="logOut">{{userInfo.USER_NAME}}</a>
      <div class="user-menu">
        <a href="javascript:;" @click="showChangePwd = true">修改密码</a>
        <a href="javascript:;" @click="logOut">注销登录</a>
      </div>
    </div>
    <el-dialog title="新增运送订单" :visible.sync="showChangePwd" size="small">
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="password"  v-model="password" name="" value="" placeholder="新密码">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="password"  v-model="repassword" name="" value="" placeholder="重复新密码">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChangePwd = false">取 消</el-button>
        <el-button type="primary" @click="saveUserPwd">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  user
} from '@/api/oli_api'
export default {
  data () {
    return {
      showChangePwd: false,
      password: '',
      repassword: ''
    }
  },
  computed: {
    formOk: {
      get () {
        return this.password && this.password === this.repassword
      }
    },
    logined: {
      get () {
        return this.$store.getters.logined
      }
    },
    userInfo: {
      get () {
        return this.$store.getters.userInfo
      }
    }
  },
  methods: {
    logOut () {
      this.$router.push({name: 'login'})
    },
    saveUserPwd () {
      if (!this.formOk) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提醒',
          message: '两次输入密码不一致'
        })
        return
      }
      let parm = {
        action: 'change_pwd',
        data: {
          USER_ID: this.userInfo['USER_ID'],
          new_pwd: this.password
        }
      }
      user(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提醒',
            message: '密码修改成功'
          })
          this.showChangePwd = false
          this.logOut()
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '系统提醒',
            message: '密码修改失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提醒',
          message: '密码修改失败'
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
.head-user {
  display: flex;
  width: 13rem;
  flex-direction:column-reverse;
}
.user-info {
  margin:0 1.5rem 0.5rem 0;
  color: #fff;
  display: flex;
  flex-direction:row;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  height: 1.5rem;
  .user-name {
    color: #fff;
    margin-left: 0.5rem;
    font-size: 1rem;
  }
  i {
    font-size: 1.5rem;
  }
}
.user-info:hover {
  .user-menu {
    display: flex;
  }
}
.user-menu {
  position: absolute;
  top: 1.5rem;
  right: 0;
  background-color: #081633;
  display: none;
  flex-direction: column;
  a {
    height: 2rem;
    display: flex;
    font-size: 0.8rem;
    margin-bottom: 0.2rem;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    color: #fff;
    border-bottom: 3px solid #081633;
    flex: 1;
  }
  a:hover {
    border-bottom: 3px solid #00ccff;
  }
}
</style>



// WEBPACK FOOTER //
// UserInfo.vue?eda1946e